import RenderforestIcon from 'assets/svgr-icons/Render.svg'
import GrokIcon from 'assets/svgr-icons/Grok.svg'
import GptIcon from 'assets/svgr-icons/Gpt.svg'
import NanoIcon from 'assets/svgr-icons/Nano.svg'
import FluxIcon from 'assets/svgr-icons/Flux.svg'
import SeedreamIcon from 'assets/svgr-icons/Seedream.svg'
import { IGroupMeta } from 'containers/SubSidebar/shared/GroupedModelDropdown'

export const AI_IMAGE_MODEL_GROUP_META: Record<string, IGroupMeta> = {
  renderforest: {
    label: 'Renderforest',
    order: 1,
    Icon: RenderforestIcon
  },
  grok: {
    label: 'Grok',
    order: 2,
    Icon: GrokIcon
  },
  gpt: {
    label: 'GPT',
    order: 3,
    Icon: GptIcon
  },
  nano: {
    label: 'Nano Banana',
    order: 4,
    Icon: NanoIcon
  },
  seedream: {
    label: 'Seedream',
    order: 5,
    Icon: SeedreamIcon
  },
  flux: {
    label: 'Flux',
    order: 6,
    Icon: FluxIcon
  }
}

export const AI_IMAGE_MODEL_GROUP_MATCHERS: Record<string, RegExp> = {
  renderforest: /renderforest/i,
  grok: /\bgrok\b/i,
  gpt: /\bgpt\b/i,
  nano: /\bnano\b/i,
  seedream: /\bseedream\b/i,
  flux: /\bflux\b/i
}
